import PrimaryButton from '../../../components/PrimaryButton/PrimaryButton'
import { useAppState } from '../../../context/appStateContext'
import useStrings from '../../../localization/useStrings'
import native from '../../../native/native'
import { formatCurrency } from '../../../utils/utils'
import { useFreeTrialPaywall } from '../freeTrialPaywallContext'
import styles from './FreeTrialPaywallFooter.module.scss'

const FreeTrialPaywallFooter = () => {
  const { actions } = useFreeTrialPaywall()
  const { state } = useAppState()
  const strings = useStrings().freeTrialPaywall

  const yearly = state.productData!.premium.yearlyProduct
  const monthly = state.productData!.premium.monthlyProduct
  const yearlyPrice = formatCurrency(yearly.price, yearly.priceLocale)
  const monthlyPrice = formatCurrency(monthly.price, monthly.priceLocale)

  return (
    <div className={styles.footer}>
      <label className={styles.title} style={{ whiteSpace: "pre-line" }}>
        {strings.footerTitle(yearlyPrice, monthlyPrice)}
      </label>
      <PrimaryButton className={styles.cta} onClick={() => native.subscribe(yearly)}>
        {strings.startTrial}
      </PrimaryButton>
      <button
        className={styles.viewPlans}
        onClick={() => {
          actions.setShowPlanSheet(true)
        }}
      >
        {strings.viewAllPlans}
      </button>
      <label className={styles.disclaimer}>{strings.footerDisclaimer}</label>
    </div>
  )
}

export default FreeTrialPaywallFooter
